
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 34","fill":"#FFF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.6.2c.8 0 1.5.3 2.1.8 1.4 1.2 1.5 3.2.3 4.6L7.6 14l7.5 8.4c1.2 1.4 1 3.4-.3 4.6-1.4 1.2-3.4 1.1-4.6-.3L1 16.2C-.1 15-.1 13.1 1 11.9l9.2-10.6C10.8.6 11.7.2 12.6.2z"}})])
          )
        }
      }
    